import React, { Component } from 'react';
import { connect } from 'react-redux';
import { zeroPad } from 'react-countdown-now';
import { FaSync, FaPencilAlt, FaEye, FaEyeSlash, FaExclamationCircle, FaRedo, FaSpinner, FaTrash } from 'react-icons/fa';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import Spinner from '../../components/UI/Spinner/Spinner';
import Modal from '../../components/UI/Modal/Modal';
import Success from '../../components/UI/Success/Success';
import Switch from '../../components/UI/Switch/Switch';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';
import ResidentNetworks from '../../containers/PropertyManager/ResidentNetworks/ResidentNetworks';
import PspView from '../../containers/PropertyManager/PspView/PspView';
import * as actions from '../../store/actions/index';
import classes from './NetworksPage.css';
const SESSION_DURATION_OPTIONS = [
  { value: 4, label: '4 hours', units: 'HOURS' },
  { value: 8, label: '8 hours', units: 'HOURS' },
  { value: 16, label: '16 hours', units: 'HOURS' },
  { value: 24, label: '24 hours', units: 'HOURS' },
];

const SESSION_DURATION_PLACEHOLDER = { value: null, label: 'Select duration' };

const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DAY_KEYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
const MINUTES = ['00'];

const CONNECTION_FILTERS = [
  { value: 'All', label: 'All' },
  { value: 'CONNECTED', label: 'CONNECTED' },
  { value: 'DISCONNECTED', label: 'DISCONNECTED' },
];

const ITEMS_PER_PAGE = 10;

const NETWORK_TYPE_LABELS = {
  ADMIN: 'ADMIN NETWORK',
  GUEST: 'GUEST NETWORK',
  STAFF: 'STAFF NETWORK',
  OFFICE: 'OFFICE NETWORK',
  IOT: 'IOT NETWORK',
};

const getPauseErrorMessage = (status) => {
  if (status === 404) return 'No devices found for this network.';
  if (status === 424) return 'Failed dependency.';
  if (status === 500) return 'Internal server error.';
  return 'An error occurred. Please try again.';
};

class NetworksPage extends Component {
  state = {
    showPassword: false,
    currentPage: 1,
    connectionFilter: 'All',
    activeTab: 'Devices',
    selectedDevice: null,
    showPauseConfirm: false,
    pendingPauseAction: null,
    showPauseSuccess: false,
    showPauseError: false,
    pauseErrorMessage: '',
    showPauseErrorDetails: false,
    pauseActionErrorMessage: null,
    showPauseActionErrorDetails: false,
    pauseToast: null,
    pauseToggleDisabled: false,
    optimisticPaused: null,
    showEditModal: false,
    showConfirmModal: false,
    editSsidName: '',
    editPassword: '',
    editBroadcast: true,
    showEditPassword: false,
    showConfirmPassword: false,
    showSsidGuidelines: false,
    showPasswordGuidelines: false,
    ssidError: '',
    passwordError: '',
    showSuccessModal: false,
    retrying: false,
    retryAttempted: false,
    deviceLoadDelay: true,
    refreshingDevices: false,
    // Network Availability modal
    showAvailabilityModal: false,
    availabilityEnabled: false,
    availabilityDays: { sunday: false, monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false },
    availabilityStartHour: 12,
    availabilityStartMinute: '00',
    availabilityStartAmPm: 'AM',
    availabilityStopHour: 11,
    availabilityStopMinute: '00',
    availabilityStopAmPm: 'PM',
    availabilityApiError: null,
    showAvailabilityErrorDetails: false,
    // Session Duration modal
    showSessionModal: false,
    sessionDuration: SESSION_DURATION_PLACEHOLDER,
    sessionExpired: false,
    guestSuccessMessage: null,
    sessionApiError: null,
    showSessionErrorDetails: false,
    sessionCounter: 0,
  };

  componentDidMount() {
    if (this.props.selectedNetwork) {
      this.setState({ activeTab: this.getDefaultTab(this.props.selectedNetwork.wifiType) });
      this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
      if (this.props.selectedNetwork.wifiType === 'GUEST') {
        this.props.getGuestNetworkSession();
        this.props.getGuestNetworkSchedule();
      }
    }
    this._deviceLoadTimer = setTimeout(() => {
      this.setState({ deviceLoadDelay: false });
    }, 3000);

  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedNetwork &&
      (!prevProps.selectedNetwork ||
        prevProps.selectedNetwork.wifiType !== this.props.selectedNetwork.wifiType)
    ) {
      this.setState({
        currentPage: 1,
        connectionFilter: 'All',
        showEditModal: false,
        showConfirmModal: false,
        showPassword: false,
        activeTab: this.getDefaultTab(this.props.selectedNetwork.wifiType),
        deviceLoadDelay: true,
        selectedDevice: null,
      });
      this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
      if (this.props.selectedNetwork.wifiType === 'GUEST') {
        this.props.getGuestNetworkSession();
        this.props.getGuestNetworkSchedule();
      }
      if (this._deviceLoadTimer) clearTimeout(this._deviceLoadTimer);
      this._deviceLoadTimer = setTimeout(() => {
        this.setState({ deviceLoadDelay: false });
      }, 3000);
    }
    if (!prevProps.updateNetworkSuccess && this.props.updateNetworkSuccess) {
      this.setState({ showConfirmModal: false, showEditModal: false, showSuccessModal: true, showPassword: false });
      setTimeout(() => this.setState({ showSuccessModal: false }), 3000);
      if (this.props.selectedNetwork) {
        this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
      }
    }
    if (!prevProps.updateNetworkError && this.props.updateNetworkError) {
      if (this.state.retryAttempted) {
        this.setState({ showConfirmModal: false, showEditModal: false, retryAttempted: false });
      } else {
        this.setState({ showConfirmModal: false, showEditModal: true });
      }
    }
    // Guest Schedule
    if (!prevProps.updateGuestScheduleSuccess && this.props.updateGuestScheduleSuccess) {
      this.setState({ showAvailabilityModal: false, availabilityApiError: null, guestSuccessMessage: 'Guest network availability changes saved. Please note it may take up to 10 minutes to reflect the changes.' });
      setTimeout(() => this.setState({ guestSuccessMessage: null }), 5000);
      this.props.getGuestNetworkSchedule();
    }
    if (!prevProps.updateGuestScheduleError && this.props.updateGuestScheduleError) {
      const { status, message } = this.props.updateGuestScheduleError;
      this.setState({ showAvailabilityModal: true, availabilityApiError: { status, message: message || 'Something went wrong. Please try again.', fromSave: true }, showAvailabilityErrorDetails: false });
    }
    // Guest Session
    if (!prevProps.updateGuestSessionSuccess && this.props.updateGuestSessionSuccess) {
      if (this._sessionCounterTimer) clearInterval(this._sessionCounterTimer);
      this.setState({ showSessionModal: false, sessionExpired: false, sessionCounter: 0, guestSuccessMessage: 'Guest network session duration changes saved. Please note it may take up to 10 minutes to reflect the changes.' });
      setTimeout(() => this.setState({ guestSuccessMessage: null }), 5000);
    }
    if (!prevProps.pauseNetworkDeviceSuccess && this.props.pauseNetworkDeviceSuccess) {
      this._pauseJustSucceeded = true;
      this.setState({ pauseToast: this.state.lastPauseAction || 'pause' });
      setTimeout(() => {
        this._pauseJustSucceeded = false;
        this.setState({ pauseToast: null, lastPauseAction: null });
      }, 3000);
    }
    if (!prevProps.pauseNetworkDeviceError && this.props.pauseNetworkDeviceError) {
      const errMsg = this.props.pauseNetworkDeviceError?.message || null;
      this.setState({ optimisticPaused: null, pauseToast: `${this.state.lastPauseAction || 'pause'}_error`, pauseActionErrorMessage: errMsg, showPauseActionErrorDetails: false });
      this.props.clearPauseNetworkDeviceError();
    }
    if (!prevProps.devicePauseStateError && this.props.devicePauseStateError) {
      if (this._pauseJustSucceeded) return;
      this.setState({ showPauseError: true, pauseErrorMessage: getPauseErrorMessage(this.props.devicePauseStateError.status), pauseToggleDisabled: true, lastPauseStatePayload: this.state.selectedDevice ? { macAddress: this.state.selectedDevice.deviceMacAddress, wifiType: this.props.selectedNetwork?.wifiType } : null });
    }
    if (prevProps.devicePauseStateLoading && !this.props.devicePauseStateLoading && !this.props.devicePauseStateError) {
      this.setState({ pauseToggleDisabled: false });
    }
    if ((!prevProps.devicePauseStateLoading && !prevProps.devicePauseState && this.props.devicePauseState)
      || (prevProps.devicePauseStateLoading && !this.props.devicePauseStateLoading && this.props.devicePauseState)) {
      this.setState({ optimisticPaused: null });
    }
    if (!prevProps.updateGuestSessionError && this.props.updateGuestSessionError) {
      if (this._sessionCounterTimer) clearInterval(this._sessionCounterTimer);
      const { status, message } = this.props.updateGuestSessionError;
      this.setState({ showSessionModal: true, sessionCounter: 0, sessionApiError: { status, message: message || 'Something went wrong. Please try again.', fromSave: true }, showSessionErrorDetails: false });
    }
    // Guest session polling counter
    if (!prevProps.guestSessionPolling && this.props.guestSessionPolling) {
      this.setState({ sessionCounter: 0, showSessionModal: true });
      this._sessionCounterTimer = setInterval(() => {
        this.setState(s => ({ sessionCounter: s.sessionCounter + 1 }));
      }, 1000);
    }
    if (prevProps.guestSessionPolling && !this.props.guestSessionPolling) {
      if (this._sessionCounterTimer) clearInterval(this._sessionCounterTimer);
      this.setState({ sessionCounter: 0 });
    }
  }

  componentWillUnmount() {
    if (this._deviceLoadTimer) clearTimeout(this._deviceLoadTimer);
    if (this._refreshTimer) clearTimeout(this._refreshTimer);
    if (this._sessionCounterTimer) clearInterval(this._sessionCounterTimer);
  }

  isCssoUser = () => {
    return (sessionStorage.getItem("userRoles") || []).includes('CSSO');
  };

  isMduNonBulk = () => {
    return this.props.isMduNonBulk || this.props.accountClassification === 'MDUNONBULK';
  };

 isMduBulk = () => {
    return this.props.isMduBulk || this.props.accountClassification === 'MDUBULK';
  };

  getDefaultTab = (wifiType) => {
    const availableTabs = this.getAvailableTabs(wifiType);
    if (availableTabs.includes('NetworkInfo')) return 'NetworkInfo';
    return 'Devices';
  };

  getAvailableTabs = (wifiType) => {
    if (this.isMduNonBulk()) return ['NetworkInfo', 'Devices'];
    if (this.isMduBulk()) {
      if (this.props.isSpectrumReady) {
        if (wifiType === 'IOT') return ['NetworkInfo', 'Devices'];
        if (wifiType === 'GUEST') return ['NetworkInfo'];
        if (['STAFF', 'OFFICE', 'ADMIN'].includes(wifiType)) return ['Devices'];
      }
      return ['NetworkInfo'];
    }
    const isCsso = this.isCssoUser();
    const isClassificationNull = !this.props.accountClassification;
    if (wifiType === 'IOT') {
      return (this.props.isSpectrumReady || isClassificationNull) ? ['NetworkInfo', 'Devices'] : ['NetworkInfo'];
    }
    if (wifiType === 'GUEST') return ['NetworkInfo'];
    if (isCsso && ['STAFF', 'OFFICE', 'ADMIN'].includes(wifiType)) return ['Devices'];
    return ['Devices'];
  };

  canEditNetwork = () => {
    // Only CSSO users can edit Wi-Fi network for all network types
    return this.isCssoUser();
  };

  isPasswordEditable = () => {
    const { selectedNetwork } = this.props;
    return selectedNetwork && selectedNetwork.wifiType !== 'GUEST';
  };

  handleRefresh = () => {
    if (this.props.selectedNetwork) {
      this.setState({ refreshingDevices: true });
      if (this._refreshTimer) clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => {
        this.props.getNetworkDevices(this.props.selectedNetwork.wifiType);
        this.setState({ refreshingDevices: false });
      }, 3000);
    }
  };

  openEditModal = () => {
    const { selectedNetwork } = this.props;
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({
      showEditModal: true,
      editSsidName: selectedNetwork.wifiSsidName || '',
      editPassword: selectedNetwork.wifiSsidPassphrase || '',
      editBroadcast: selectedNetwork.broadcast !== undefined ? selectedNetwork.broadcast : true,
      showEditPassword: false,
      showConfirmPassword: false,
      showSsidGuidelines: false,
      showPasswordGuidelines: false,
      ssidError: '',
      passwordError: '',
    });
  };

  validateSsid = (value) => {
    if (!value || !value.trim()) return 'Please enter a Network Name (SSID).';
    if (value.length < 3) return 'Please keep the length between 3-32 characters.';
    if (/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value)) return "Please choose a name that doesn't start or end with a special character or space.";
    if (/[$<>`\\^&;"]/.test(value)) return "The following characters are not allowed $ < > ` \\ ^ & ; \"";
    return '';
  };

  validatePassword = (value) => {
    if (!value || !value.trim()) return 'Please enter a password.';
    if (value.length < 8) return 'Please keep the length between 8-29 characters.';
    if (/^[^a-zA-Z0-9]|[^a-zA-Z0-9]$/.test(value)) return "Please choose a password that doesn't start or end with a special character or space.";
    if (/[$<>`\\^&;"']/.test(value)) return "The following characters are not allowed $ < > ` \\ ^ & ; \" '";
    return '';
  };

  handleSsidChange = (e) => {
    const value = e.target.value;
    this.setState({ editSsidName: value, ssidError: this.validateSsid(value) });
  };

  handlePasswordChange = (e) => {
    const value = e.target.value;
    this.setState({ editPassword: value, passwordError: this.validatePassword(value) });
  };

  handleSave = () => {
    const ssidError = this.validateSsid(this.state.editSsidName);
    const passwordError = this.isPasswordEditable() ? this.validatePassword(this.state.editPassword) : '';
    if (ssidError || passwordError) {
      this.setState({ ssidError, passwordError });
      return;
    }
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({ showConfirmModal: true, showEditModal: false });
  };

  handleConfirm = () => {
    const { selectedNetwork } = this.props;
    const { editSsidName, editPassword, editBroadcast } = this.state;
    const payload = {
      wifiSsidName: editSsidName,
      broadcast: editBroadcast,
      enabled: selectedNetwork.enabled,
      wifiType: selectedNetwork.wifiType,
      masterAcct: selectedNetwork.bulkMasterAccount,
      configType: selectedNetwork.configType,
    };
    if (this.isPasswordEditable()) {
      payload.wifiSsidPassphrase = editPassword;
    }
    this.props.updateNetwork(payload);
  };

  handleRetry = () => {
    if (this.props.clearUpdateNetworkError) {
      this.props.clearUpdateNetworkError();
    }
    this.setState({ retrying: true, retryAttempted: true });
    setTimeout(() => {
      this.setState({ retrying: false });
      this.handleConfirm();
    }, 2000);
  };

  handleCancelEdit = () => {
    this.setState({ showEditModal: false, showConfirmModal: false, retrying: false, retryAttempted: false });
  };

  getDefaultAvailabilityState = () => ({
    availabilityEnabled: false,
    availabilityDays: { sunday: false, monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false },
    availabilityStartHour: 12,
    availabilityStartMinute: '00',
    availabilityStartAmPm: 'AM',
    availabilityStopHour: 11,
    availabilityStopMinute: '00',
    availabilityStopAmPm: 'PM',
  });

  openAvailabilityModal = () => {
    const { guestSchedule } = this.props;
    const schedule = guestSchedule || {};
    const enabled = schedule.enabled || false;
    const allFalse = { sunday: false, monday: false, tuesday: false, wednesday: false, thursday: false, friday: false, saturday: false };
    const days = schedule.daysOfTheWeek || allFalse;
    let startHour = 12, startMinute = '00', startAmPm = 'AM';
    let stopHour = 11, stopMinute = '00', stopAmPm = 'PM';
    if (schedule.schedule?.startTime) {
      const [h, m] = schedule.schedule.startTime.split(':');
      const hr = parseInt(h, 10);
      startAmPm = hr < 12 ? 'AM' : 'PM';
      startHour = hr % 12 || 12;
      startMinute = m || '00';
    }
    if (schedule.schedule?.endTime) {
      const [h, m] = schedule.schedule.endTime.split(':');
      const hr = parseInt(h, 10);
      stopAmPm = hr < 12 ? 'AM' : 'PM';
      stopHour = hr % 12 || 12;
      stopMinute = m || '00';
    }
    this.props.clearGuestNetworkError();
    const initialSnapshot = { enabled, days: { ...days }, startHour, startMinute, startAmPm, stopHour, stopMinute, stopAmPm };
    this.setState({ showAvailabilityModal: true, availabilityEnabled: enabled, availabilityDays: { ...days }, availabilityStartHour: startHour, availabilityStartMinute: startMinute, availabilityStartAmPm: startAmPm, availabilityStopHour: stopHour, availabilityStopMinute: stopMinute, availabilityStopAmPm: stopAmPm, guestSuccessMessage: null, availabilityApiError: null, _initialAvailability: initialSnapshot });
  };

  hasAvailabilityChanged = () => {
    const snap = this.state._initialAvailability;
    if (!snap) return true;
    const { availabilityEnabled, availabilityDays, availabilityStartHour, availabilityStartMinute, availabilityStartAmPm, availabilityStopHour, availabilityStopMinute, availabilityStopAmPm } = this.state;
    if (availabilityEnabled !== snap.enabled) return true;
    if (availabilityStartHour !== snap.startHour || availabilityStartMinute !== snap.startMinute || availabilityStartAmPm !== snap.startAmPm) return true;
    if (availabilityStopHour !== snap.stopHour || availabilityStopMinute !== snap.stopMinute || availabilityStopAmPm !== snap.stopAmPm) return true;
    return DAY_KEYS.some(k => !!availabilityDays[k] !== !!snap.days[k]);
  };

  handleSaveAvailability = () => {
    const { availabilityEnabled, availabilityDays, availabilityStartHour, availabilityStartMinute, availabilityStartAmPm, availabilityStopHour, availabilityStopMinute, availabilityStopAmPm } = this.state;
    const toHour24 = (h, ampm) => {
      let hr = parseInt(h, 10);
      if (ampm === 'AM') return hr === 12 ? 0 : hr;
      return hr === 12 ? 12 : hr + 12;
    };
    const startH = toHour24(availabilityStartHour, availabilityStartAmPm);
    const stopH = toHour24(availabilityStopHour, availabilityStopAmPm);
    const payload = {
      enabled: availabilityEnabled,
      daysOfTheWeek: {
        monday: !!availabilityDays.monday,
        tuesday: !!availabilityDays.tuesday,
        wednesday: !!availabilityDays.wednesday,
        thursday: !!availabilityDays.thursday,
        friday: !!availabilityDays.friday,
        saturday: !!availabilityDays.saturday,
        sunday: !!availabilityDays.sunday,
      },
      schedule: availabilityEnabled ? {
        startTime: `${String(startH).padStart(2, '0')}:${availabilityStartMinute}`,
        endTime: `${String(stopH).padStart(2, '0')}:${availabilityStopMinute}`,
      } : undefined,
    };
    this.props.updateGuestNetworkSchedule(payload);
  };

  openSessionModal = () => {
    this.props.clearGuestNetworkError();
    const { guestSession } = this.props;
    const prefill = guestSession?.duration
      ? SESSION_DURATION_OPTIONS.find(o => o.value === guestSession.duration && o.units === guestSession.units) || SESSION_DURATION_PLACEHOLDER
      : SESSION_DURATION_PLACEHOLDER;
    this.setState({ showSessionModal: true, sessionDuration: prefill, guestSuccessMessage: null, sessionApiError: null });
  };

  handleSaveSession = () => {
    const { sessionDuration } = this.state;
    if (!sessionDuration.value) return;
    this.props.updateGuestNetworkSession({ enabled: true, units: sessionDuration.units, duration: sessionDuration.value });
  };

  renderAvailabilitySummary = () => {
    const schedule = this.props.guestSchedule;
    if (!schedule?.enabled) return 'Always On';
    const days = schedule.daysOfTheWeek || {};
    const selectedDays = DAY_KEYS.filter(k => days[k]);
    const allSelected = selectedDays.length === 7;
    const formatTime = (timeStr) => {
      if (!timeStr) return '';
      const [h, m] = timeStr.split(':');
      const hr = parseInt(h, 10);
      const ampm = hr < 12 ? 'AM' : 'PM';
      const displayHr = hr % 12 || 12;
      return `${displayHr}:${m} ${ampm}`;
    };
    const compressDays = (keys) => {
      if (!keys.length) return '';
      const indices = keys.map(k => DAY_KEYS.indexOf(k));
      const ranges = [];
      let start = indices[0], end = indices[0];
      for (let i = 1; i < indices.length; i++) {
        if (indices[i] === end + 1) {
          end = indices[i];
        } else {
          ranges.push(end > start ? `${DAYS[start]}-${DAYS[end]}` : DAYS[start]);
          start = end = indices[i];
        }
      }
      ranges.push(end > start ? `${DAYS[start]}-${DAYS[end]}` : DAYS[start]);
      return ranges.join(', ');
    };
    const startLabel = formatTime(schedule.schedule?.startTime);
    const endLabel = formatTime(schedule.schedule?.endTime);
    const timeRange = startLabel && endLabel ? ` ${startLabel} - ${endLabel}` : '';
    if (allSelected) return `Daily:${timeRange}`;
    if (!selectedDays.length) return 'Always On';
    const unselectedDays = DAY_KEYS.filter(k => !days[k]);
    const parts = [];
    parts.push(`${compressDays(selectedDays)}:${timeRange}`);
    if (unselectedDays.length) parts.push(`${compressDays(unselectedDays)}: Always On`);
    return parts.join(' | ');
  };

  getFilteredDevices = () => {
    const { networkDevices } = this.props;
    const { connectionFilter } = this.state;
    if (!networkDevices || !networkDevices.length) return [];
    if (connectionFilter === 'All') return networkDevices;
    const stateMap = { CONNECTED: ['CONNECTED', 'ACTIVE'], DISCONNECTED: ['DISCONNECTED', 'OFFLINE'] };
    const allowed = stateMap[connectionFilter] || [connectionFilter];
    return networkDevices.filter((d) => {
      return d.connectionState && allowed.includes(d.connectionState.toUpperCase());
    });
  };

  isSignalMissing = (device) => {
    const s = device?.health?.status;
    return !s || s.trim() === '';
  };

  getSignalDot = (device) => {
    if (this.isSignalMissing(device)) return null;
    const status = device.health.status.toLowerCase();
    const color = status === 'offline' || status === 'poor' || status === 'fair' ? '#d6312b' : 'green';
    return <span className={classes.SignalDot} style={{ backgroundColor: color }} />;
  };

  getSignalLabel = (device) => {
    if (this.isSignalMissing(device)) {
      return <span>N/A</span>;
    }
    const status = device.health.status.charAt(0).toUpperCase() + device.health.status.slice(1).toLowerCase();
    const color = status === 'Poor' || status === 'Fair' || status === 'Offline' ? '#d6312b' : 'green';
    return <span style={{ color }}>{status}</span>;
  };

  getFreq = (device) => {
    if (!device.connectionState) return 'N/A';
    const conn = device.connectionState;
    if (conn.includes('6G')) return '6 GHz';
    if (conn.includes('5G')) return '5 GHz';
    if (conn.includes('2.4G') || conn.includes('2G')) return '2.4 GHz';
    if (conn.toLowerCase().includes('ethernet')) return 'Ethernet';
    return conn;
  };

  getConnectionStatus = (device) => {
    if (!device.connectionState) return 'N/A';
    const state = device.connectionState;
    return state.charAt(0).toUpperCase() + state.slice(1).toLowerCase();
  };

  renderPagination = (totalItems) => {
    const { currentPage } = this.state;
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE) || 1;

    const pages = [];
    for (let i = 1; i <= totalPages; i++) pages.push(i);

    const startItem = totalItems === 0 ? 0 : (currentPage - 1) * ITEMS_PER_PAGE + 1;
    const endItem = Math.min(currentPage * ITEMS_PER_PAGE, totalItems);

    return (
      <div className={classes.Pagination}>
        <button
          className={classes.PaginationBtn}
          disabled={currentPage === 1}
          onClick={() => this.setState({ currentPage: currentPage - 1 })}
          aria-label="previous page"
        >
          <MdKeyboardArrowLeft size={18} />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            className={[classes.PaginationBtn, currentPage === p ? classes.PaginationBtnActive : ''].join(' ')}
            onClick={() => this.setState({ currentPage: p })}
          >
            {p}
          </button>
        ))}
        <button
          className={classes.PaginationBtn}
          disabled={currentPage === totalPages}
          onClick={() => this.setState({ currentPage: currentPage + 1 })}
          aria-label="next page"
        >
          <MdKeyboardArrowRight size={18} />
        </button>
        <span className={classes.PaginationInfo}>
          {startItem}-{endItem} of {totalItems} items
        </span>
      </div>
    );
  };

  render() {
    const { selectedNetwork, networkDevicesLoading, updateNetworkLoading } = this.props;
    const { showPassword, currentPage, connectionFilter, activeTab,
      showEditModal, showConfirmModal, editSsidName, editPassword,
      editBroadcast, showEditPassword, showConfirmPassword,
      showSsidGuidelines, showPasswordGuidelines, ssidError, passwordError,
      showAvailabilityModal, availabilityEnabled, availabilityDays,
      availabilityStartHour, availabilityStartMinute, availabilityStartAmPm,
      availabilityStopHour, availabilityStopMinute, availabilityStopAmPm,
      availabilityApiError,
      showSessionModal, sessionDuration } = this.state;

    if (!selectedNetwork) {
      // MDUNONBULK: No left panel networks, show Network Info directly
      if (this.isMduNonBulk() || this.isMduBulk()) {
        return (
          <div className={classes.NetworksPage}>
            <div className={classes.HeaderCard}>
              {(!this.isMduNonBulk() || this.props.isSpectrumReady) && (
                <h2 className={classes.NetworkName} style={{ marginBottom: 10 }}>Resident Network</h2>
              )}
              <div className={classes.TabsRow}>
                <button className={[classes.Tab, classes.TabActive].join(' ')}>
                  Network Info
                </button>
              </div>
            </div>
            <div className={classes.DevicesSection}>
              {this.props.tenantDetailsError ? (
                <div className={classes.ErrorCard}>
                  <div className={classes.ErrorIconRow}>
                    <FaExclamationCircle size={22} color="#d6312b" />
                    <span className={classes.ErrorTitle}>Error</span>
                  </div>
                  <p className={classes.ErrorMessage}>
                    UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.
                  </p>
                  <button className={classes.RefreshLink} onClick={() => this.props.getTenantData({})}>Refresh</button>
                </div>
              ) : this.props.tenantDetails && this.props.tenantDetails.content ? (
                <>
                  <div className={classes.IotStatsWrapper}>
                    <ResidentNetworks
                      getTenantData={this.props.getTenantData}
                      tenantStats={this.props.tenantStats}
                      filter={this.props.filter}
                      isLoading={this.props.tenantDetailsLoading}
                      tenantDetails={this.props.tenantDetails}
                    />
                  </div>
                  <div className={classes.IotTableWrapper}>
                    <PspView
                      tenantDetails={this.props.tenantDetails}
                      getTenantData={this.props.getTenantData}
                      onGetTenant={this.props.onGetTenant}
                      filter={this.props.filter}
                      isLoading={this.props.tenantDetailsLoading}
                      iotConfigured={this.props.iotConfigured}
                    />
                  </div>
                </>
              ) : (
                <Spinner />
              )}
            </div>
          </div>
        );
      }
      return (
        <div className={classes.EmptyState}>
          <p>Select a network from the left panel to view details.</p>
        </div>
      );
    }

    // Hide Home network from right panel
    if (selectedNetwork.wifiType === 'HOME' && !this.isMduBulk()) {
      return (
        <div className={classes.EmptyState}>
          <p>Select a network from the left panel to view details.</p>
        </div>
      );
    }

    const networkDevices = this.props.networkDevices || [];
    const filteredDevices = this.getFilteredDevices();
    const totalDevices = networkDevices.length;
    const connectedDevices = networkDevices.filter((d) => {
      const state = d.connectionState && d.connectionState.toUpperCase();
      return state === 'ACTIVE' || state === 'CONNECTED';
    }).length;
    const disconnectedDevices = networkDevices.filter((d) => {
      const state = d.connectionState && d.connectionState.toUpperCase();
      return state === 'OFFLINE' || state === 'DISCONNECTED';
    }).length;
    const pausedDevices = networkDevices.filter((d) => d.connectionState && d.connectionState.toUpperCase() === 'PAUSED').length;

    const indexOfLast = currentPage * ITEMS_PER_PAGE;
    const indexOfFirst = indexOfLast - ITEMS_PER_PAGE;
    const currentDevices = filteredDevices.slice(indexOfFirst, indexOfLast);

    const networkTypeLabel = NETWORK_TYPE_LABELS[selectedNetwork.wifiType] || selectedNetwork.wifiType;
    const password = selectedNetwork.wifiSsidPassphrase || '';
    const visibility = selectedNetwork.broadcast ? 'Visible' : 'Hidden';
    const availableTabs = this.getAvailableTabs(selectedNetwork.wifiType);
    const hasPassword = !!selectedNetwork.wifiSsidPassphrase;

    if (this.state.selectedDevice) {
      const dev = this.state.selectedDevice;
      const { devicePauseState, devicePauseStateLoading, pauseNetworkDeviceLoading } = this.props;
      const serverIsPaused = !!(devicePauseState?.pauseState?.toUpperCase() === 'PAUSED'
        || devicePauseState?.paused === true
        || devicePauseState?.connectionState?.toUpperCase() === 'PAUSED'
        || devicePauseState?.state?.toUpperCase() === 'PAUSED');
      const isPaused = this.state.optimisticPaused !== null ? this.state.optimisticPaused : serverIsPaused;
      const signalStatus = dev.health?.status
        ? dev.health.status.charAt(0).toUpperCase() + dev.health.status.slice(1).toLowerCase()
        : null;
      const signalColor = !signalStatus ? 'black'
        : ['excellent', 'good', 'connected', 'active'].includes(dev.health.status.toLowerCase()) ? 'green'
        : ['poor', 'fair', 'disconnected', 'offline'].includes(dev.health.status.toLowerCase()) ? '#d6312b'
        : dev.health.status.toLowerCase() === 'calculating' ? 'orange'
        : 'black';
      const fields = [
        { label: 'Pause State', value: this.state.pauseToggleDisabled ? 'Off' : (isPaused ? 'On' : 'Off') },
        { label: 'Device Model', value: dev.deviceType?.model || 'N/A' },
        { label: 'Connected To', value: dev.connectedTo || 'N/A' },
        { label: 'Connection', value: dev.connection?.frequency || 'N/A' },
        { label: 'IP Address', value: dev.addresses?.ipv4 || dev.ipAddress || dev.ip || dev.ipv4Address || 'N/A' },
        { label: 'MAC Address', value: dev.deviceMacAddress || 'N/A' },
        { label: 'Connection Type', value: dev.connectionType || 'N/A' },
        { label: 'Device Name', value: dev.deviceName || 'N/A' },
      ];
      const rows = [];
      for (let i = 0; i < fields.length; i += 2) {
        rows.push(fields.slice(i, i + 2));
      }
      return (
        <div className={classes.NetworksPage}>
          <div className={classes.DeviceDetailPage}>
            <div className={classes.DeviceDetailTopBar}>
              <button className={classes.BackBtn} onClick={() => this.setState({ selectedDevice: null, optimisticPaused: null })}>
                &#8249; Back to Devices List
              </button>
            </div>
            <div className={classes.DeviceDetailSeparator} />
            <div className={classes.DeviceDetailHeader}>
              <div>
                <div className={classes.DeviceDetailName}>{dev.deviceName || 'Unknown Device'}</div>
                <div className={classes.DeviceDetailSignal} style={{ color: signalColor }}>
                  <span className={classes.SignalDot} style={{ backgroundColor: signalColor }} />
                  {signalStatus ? `${signalStatus} Connection` : 'N/A'}
                </div>
              </div>
              <div className={classes.DeviceDetailPauseRow}>
                <span className={classes.DeviceDetailPauseLabel}>Device Pause</span>
                {devicePauseStateLoading || pauseNetworkDeviceLoading
                  ? <FaSpinner className={classes.SpinnerIcon} style={{ color: '#0073d1' }} />
                  : <Switch
                      checked={this.state.pauseToggleDisabled ? false : isPaused}
                      disabled={this.state.pauseToggleDisabled}
                      onChange={() => this.setState({
                        showPauseConfirm: true,
                        pendingPauseAction: { macAddress: dev.deviceMacAddress, wifiType: this.props.selectedNetwork.wifiType, isPaused },
                      })}
                      onText="ON"
                      offText="OFF"
                    />
                }
              </div>
            </div>
            <div className={classes.DeviceDetailGrid}>
              {rows.map((row, ri) => (
                <div key={ri} className={classes.DeviceDetailRow}>
                  {row.map((field, fi) => (
                    <div key={fi} className={classes.DeviceDetailCell}>
                      <span className={classes.DeviceDetailLabel}>{field.label}: </span>
                      <span className={classes.DeviceDetailValue}>{field.value}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          {/* Pause Confirmation Modal */}
          <Modal show={this.state.showPauseConfirm} modalClosed={() => this.setState({ showPauseConfirm: false, pendingPauseAction: null })} deviceGroupConfirmation="true">
            <div className={classes.ConfirmModalBody}>
              <div className={classes.ConfirmContent}>
                <p className={classes.ConfirmText} style={{ fontWeight: 700, fontSize: 16 }}>
                  {this.state.pendingPauseAction?.isPaused
                    ? 'Are you sure you want to unpause this device?'
                    : 'This will pause all internet connectivity to this device. Are you sure you want to pause this device?'
                  }
                </p>
                <div className={classes.ConfirmActions}>
                  <button className={classes.CancelBtn} onClick={() => this.setState({ showPauseConfirm: false, pendingPauseAction: null })}>Cancel</button>
                  <button
                    className={classes.SaveBtn}
                    onClick={() => {
                      const { pendingPauseAction } = this.state;
                      this.setState({ showPauseConfirm: false, pendingPauseAction: null, optimisticPaused: !pendingPauseAction.isPaused });
                      if (pendingPauseAction.isPaused) {
                        this.setState({ lastPauseAction: 'unpause', lastPauseDevicePayload: { macAddress: pendingPauseAction.macAddress, wifiType: pendingPauseAction.wifiType } });
                        this.props.unpauseNetworkDevice({ macAddress: pendingPauseAction.macAddress, wifiType: pendingPauseAction.wifiType });
                      } else {
                        this.setState({ lastPauseAction: 'pause', lastPauseDevicePayload: { macAddress: pendingPauseAction.macAddress, wifiType: pendingPauseAction.wifiType } });
                        this.props.pauseNetworkDevice({ macAddress: pendingPauseAction.macAddress, wifiType: pendingPauseAction.wifiType });
                      }
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </Modal>

          {/* Pause Action Toast */}
          <Modal show={!!this.state.pauseToast} modalClosed={() => this.setState({ pauseToast: null, lastPauseAction: null })}>
            {(this.state.pauseToast === 'pause' || this.state.pauseToast === 'unpause')
              ? <Success message={this.state.pauseToast === 'unpause' ? 'Unpause Success' : 'Pause Success'} />
              : (
                <>
                  <div className={classes.ApiErrorBox}>
                    <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0, marginTop: 2 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <p className={classes.ApiErrorText} style={{ margin: 0 }}>
                          {this.state.pauseToast === 'unpause_error' ? 'Unpause Unsuccessful. Please try again.' : 'Pause Unsuccessful. Please try again.'}
                        </p>
                        {this.state.pauseActionErrorMessage && (
                          <button
                            className={classes.TryAgainBtn}
                            style={{ fontSize: 16, padding: '0 4px' }}
                            onClick={() => this.setState(s => ({ showPauseActionErrorDetails: !s.showPauseActionErrorDetails }))}
                          >
                            <span className={[classes.GuidelinesChevron, this.state.showPauseActionErrorDetails ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
                          </button>
                        )}
                      </div>
                      <button
                        className={classes.TryAgainBtn}
                        style={{ marginTop: 4 }}
                        onClick={() => {
                          const { lastPauseAction, lastPauseDevicePayload } = this.state;
                          this.setState({ pauseToast: null, showPauseActionErrorDetails: false });
                          if (lastPauseAction === 'unpause') {
                            this.props.unpauseNetworkDevice(lastPauseDevicePayload);
                          } else {
                            this.props.pauseNetworkDevice(lastPauseDevicePayload);
                          }
                        }}
                      >
                        Try Again
                      </button>
                      {this.state.showPauseActionErrorDetails && (
                        <p className={classes.ApiErrorText} style={{ marginTop: 8, fontStyle: 'italic' }}>
                          {this.state.pauseActionErrorMessage}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className={classes.EditModalActions}>
                    <div style={{ flex: 1 }} />
                    <button
                      className={classes.CancelBtn}
                      style={{ flex: 'none', width: '160px' }}
                      onClick={() => this.setState({ pauseToast: null, lastPauseAction: null, lastPauseDevicePayload: null, showPauseActionErrorDetails: false, pauseActionErrorMessage: null })}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )
            }
          </Modal>

          {/* Pause State GET Error Modal */}
          <Modal show={this.state.showPauseError} modalClosed={() => { this.setState({ showPauseError: false, pauseErrorMessage: '', lastPauseStatePayload: null, showPauseErrorDetails: false }); }}>
            <>
              <div className={classes.ApiErrorBox}>
                <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0, marginTop: 2 }} />
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <p className={classes.ApiErrorText} style={{ margin: 0 }}>Something went wrong. Please try again.</p>
                    {this.state.pauseErrorMessage && (
                      <button
                        className={classes.TryAgainBtn}
                        style={{ fontSize: 16, padding: '0 4px' }}
                        onClick={() => this.setState(s => ({ showPauseErrorDetails: !s.showPauseErrorDetails }))}
                      >
                        <span className={[classes.GuidelinesChevron, this.state.showPauseErrorDetails ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
                      </button>
                    )}
                  </div>
                  <button
                    className={classes.TryAgainBtn}
                    style={{ marginTop: 4 }}
                    onClick={() => {
                      const { lastPauseStatePayload } = this.state;
                      this.setState({ showPauseError: false, pauseErrorMessage: '', pauseToggleDisabled: true, showPauseErrorDetails: false });
                      if (lastPauseStatePayload) {
                        this.props.getNetworkDevicePauseState(lastPauseStatePayload);
                      }
                    }}
                  >
                    Try Again
                  </button>
                  {this.state.showPauseErrorDetails && (
                    <p className={classes.ApiErrorText} style={{ marginTop: 8, fontStyle: 'italic' }}>
                      {this.state.pauseErrorMessage}
                    </p>
                  )}
                </div>
              </div>
              <div className={classes.EditModalActions}>
                <div style={{ flex: 1 }} />
                <button
                  className={classes.CancelBtn}
                  style={{ flex: 'none', width: '160px' }}
                  onClick={() => this.setState({ showPauseError: false, pauseErrorMessage: '', lastPauseStatePayload: null, pauseToggleDisabled: false, showPauseErrorDetails: false })}
                >
                  Cancel
                </button>
              </div>
            </>
          </Modal>
        </div>
      );
    }

    return (
      <div className={classes.NetworksPage}>

        {/* Header Card */}
        <div className={classes.HeaderCard}>
          <div className={classes.HeaderTop}>
            {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
              <div>
                <div className={classes.NetworkTypeLabel}>{networkTypeLabel}</div>
                <h2 className={classes.NetworkName}>{selectedNetwork.wifiSsidName}</h2>
              </div>
            )}
            {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
              <div className={classes.EditLinkWrapper}>
                <button
                  className={[classes.EditLink, !this.isCssoUser() ? classes.EditLinkDisabled : ''].join(' ')}
                  onClick={this.isCssoUser() ? this.openEditModal : undefined}
                  disabled={!this.isCssoUser()}
                >
                  <FaPencilAlt size={14} style={{ marginRight: 6 }} />
                  Edit WiFi Network Details
                </button>
                {!this.isCssoUser() && (
                  <div className={classes.EditTooltip}>
                    {selectedNetwork.wifiType === 'IOT' ? 'IoT' : selectedNetwork.wifiType.charAt(0).toUpperCase() + selectedNetwork.wifiType.slice(1).toLowerCase()} WiFi Network Details can only be edited by the CSSO team.
                  </div>
                )}
              </div>
            )}
          </div>
          {(selectedNetwork.wifiType !== 'IOT' || this.props.isSpectrumReady) && (
            <div className={classes.NetworkMeta}>
              {hasPassword && (
                <span className={classes.MetaItem}>
                  <span className={classes.MetaLabel}>Password: </span>
                  <span className={classes.PasswordDots}>
                    {showPassword ? password : '••••••••••'}
                  </span>
                  <button
                    className={classes.ShowPasswordBtn}
                    onClick={() => this.setState({ showPassword: !showPassword })}
                  >
                    {showPassword ? 'Hide Password' : 'Show Password'}
                  </button>
                </span>
              )}
              <span className={classes.MetaItem}>
                <span className={classes.MetaLabel}>Network Visibility: </span>
                <span>{visibility}</span>
              </span>
            </div>
          )}


          {/* Tabs */}
          {this.props.tenantDetails && !this.props.isSpectrumReady && !this.isMduNonBulk() && (
            <h2 className={classes.NetworkName} style={{ marginBottom: 10, marginTop: 10 }}>Resident Network</h2>
          )}
          <div className={classes.TabsRow}>
            {availableTabs.includes('NetworkInfo') && (
              <button
                className={[classes.Tab, activeTab === 'NetworkInfo' ? classes.TabActive : ''].join(' ')}
                onClick={() => this.setState({ activeTab: 'NetworkInfo' })}
              >
                Network Info
              </button>
            )}
            {availableTabs.includes('Devices') && (
              <button
                className={[classes.Tab, activeTab === 'Devices' ? classes.TabActive : ''].join(' ')}
                onClick={() => this.setState({ activeTab: 'Devices' })}
              >
                Devices
              </button>
            )}
          </div>
        </div>

        {/* Devices Section */}
        {activeTab === 'Devices' && (
          <div className={classes.DevicesSection}>

            {/* Refreshing spinner */}
            {(this.state.refreshingDevices || networkDevicesLoading) && <Spinner />}

            {/* Initial state - not yet loaded */}
            {!this.state.refreshingDevices && !networkDevicesLoading && !this.props.networkDevicesLoaded && !this.props.networkDevicesError && (
              <Spinner />
            )}

            {/* No Devices Available. */}
            {!this.state.refreshingDevices && !networkDevicesLoading && networkDevices.length === 0 && (this.props.networkDevicesError || this.props.networkDevicesLoaded) && (
              <div className={classes.DeviceListCard}>
                <div className={classes.DeviceListHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <h3 className={classes.DeviceListTitle}>Device List</h3>
                  <button className={classes.RefreshBtn} onClick={this.handleRefresh}>
                    <FaSync size={13} style={{ marginRight: 6 }} />
                    Refresh
                  </button>
                </div>
                <div className={classes.TableDivider} />
                <div className={classes.EmptyRow} style={{ padding: '24px', textAlign: 'center' }}>
                  {this.props.networkDevicesError ? getPauseErrorMessage(this.props.networkDevicesError.status) : 'No devices available.'}
                </div>
              </div>
            )}

            {/* Stats Card */}
            {!this.state.refreshingDevices && !networkDevicesLoading && !this.props.networkDevicesError && networkDevices.length > 0 && (
            <div className={classes.StatsCard}>
              <div className={classes.StatsHeader}>
                <h3 className={classes.StatsTitle}>Devices</h3>
                <button className={classes.RefreshBtn} onClick={this.handleRefresh}>
                  <FaSync size={13} style={{ marginRight: 6 }} />
                  Refresh
                </button>
              </div>
              <div className={classes.StatsDivider} />
              <div className={classes.StatsRow}>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{totalDevices}</div>
                  <div className={classes.StatLabel}>Total Devices</div>
                </div>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{connectedDevices}</div>
                  <div className={classes.StatLabel}>Connected Devices</div>
                </div>
                <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{disconnectedDevices}</div>
                  <div className={classes.StatLabel}>Disconnected Devices</div>
                </div>
                {/* <div className={classes.StatItem}>
                  <div className={classes.StatNumber}>{pausedDevices}</div>
                  <div className={classes.StatLabel}>Paused Devices</div>
                </div> */}
              </div>
            </div>

            )}

            {/* Device List Card */}
            {!this.state.refreshingDevices && !networkDevicesLoading && !this.props.networkDevicesError && networkDevices.length > 0 && (
            <div className={classes.DeviceListCard}>
              <div className={classes.DeviceListHeader}>
                <h3 className={classes.DeviceListTitle}>Device List</h3>
              </div>
              <div className={classes.TableDivider} />

              <>
                  <div className={classes.TableWrapper}>
                    <table className={classes.DeviceTable} cellPadding="0" cellSpacing="0">
                      <thead>
                        <tr>
                          <th className={classes.Th} style={{ width: '18%' }}>Device Name</th>
                          <th className={classes.Th} style={{ width: '14%' }}>Connected To</th>
                          <th className={classes.Th} style={{ width: '12%' }}>Signal</th>
                          <th className={classes.Th} style={{ width: '16%' }}>
                            <div>Connection</div>
                            <div style={{ marginTop: 4 }}>
                              <SelectDropdown
                                height={'30px'}
                                width={'120px'}
                                name="connectionFilter"
                                placeholder="All"
                                value={CONNECTION_FILTERS.filter((o) => o.value === connectionFilter)}
                                options={CONNECTION_FILTERS}
                                isSearchable={false}
                                onChange={(e) =>
                                  this.setState({ connectionFilter: e.value, currentPage: 1 })
                                }
                              />
                            </div>
                          </th>
                          <th className={classes.Th} style={{ width: '20%' }}>Device Model</th>
                          <th className={classes.Th} style={{ width: '20%' }}>Device MAC Address</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentDevices.length === 0 ? (
                          <tr>
                            <td colSpan="6" className={classes.EmptyRow}>
                              No devices available.
                            </td>
                          </tr>
                        ) : (
                          currentDevices.map((device, idx) => (
                            <tr key={device.deviceMacAddress || idx} className={classes.DeviceRow}>
                              <td className={classes.Td}>
                                <button
                                  className={classes.DeviceNameLink}
                                  onClick={() => {
                                    this.setState({ selectedDevice: device, optimisticPaused: null, showPauseError: false, pauseErrorMessage: '', pauseToggleDisabled: true, lastPauseStatePayload: { macAddress: device.deviceMacAddress, wifiType: this.props.selectedNetwork?.wifiType } });
                                    this.props.clearPauseNetworkDeviceError();
                                    this.props.getNetworkDevicePauseState({ macAddress: device.deviceMacAddress, wifiType: this.props.selectedNetwork.wifiType });
                                  }}
                                >
                                  {device.deviceName || 'Unknown Device'}
                                </button>
                              </td>
                              <td className={classes.Td}>{device.connectedTo || 'N/A'}</td>
                              <td className={classes.Td}>
                                {this.isSignalMissing(device)
                                  ? 'N/A'
                                  : <div className={classes.SignalCell}>
                                      {this.getSignalDot(device)}
                                      {this.getSignalLabel(device)}
                                    </div>
                                }
                              </td>
                              <td className={classes.Td}>
                                {device.connectionState
                                  ? (() => {
                                      const upper = device.connectionState.toUpperCase();
                                      const isConnected = upper === 'ACTIVE' || upper === 'CONNECTED';
                                      const color = isConnected ? 'green' : '#d6312b';
                                      const label = isConnected ? 'CONNECTED' : 'DISCONNECTED';
                                      return (
                                        <div className={classes.SignalCell}>
                                          <span className={classes.SignalDot} style={{ backgroundColor: color }} />
                                          <span style={{ color }}>{label}</span>
                                        </div>
                                      );
                                    })()
                                  : 'N/A'
                                }
                              </td>
                              <td className={classes.Td}>
                                {device.deviceType && device.deviceType.model ? device.deviceType.model : 'N/A'}
                              </td>
                              <td className={classes.Td}>{device.deviceMacAddress || 'N/A'}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                  {this.renderPagination(filteredDevices.length)}
                </>
            </div>
            )}
          </div>
        )}

        {/* Network Info Section - GUEST */}
        {activeTab === 'NetworkInfo' && selectedNetwork.wifiType === 'GUEST' && (
          <div className={classes.DevicesSection}>
            {/* Success Banner */}
            {this.state.guestSuccessMessage && (
              <div style={{ background: '#e8f5e9', border: '1px solid #4caf50', borderRadius: 4, padding: '12px 16px', fontSize: 14, fontWeight: 600, color: '#2e7d32' }}>
                {this.state.guestSuccessMessage}
              </div>
            )}
            {/* Network Availability */}
            <div className={classes.NetworkInfoCard}>
              <div className={classes.NetworkInfoRow}>
                <span className={classes.NetworkInfoLabel}>Network Availability</span>
                <span className={classes.NetworkInfoPipe}>|</span>
                {this.props.guestScheduleLoading ? <Spinner /> : (
                  <span className={classes.NetworkInfoValue} style={{ flex: 1 }}>
                    {this.renderAvailabilitySummary()}
                  </span>
                )}
                {this.props.guestSchedule?.enabled !== undefined ? (
                  <button className={classes.EditLink} onClick={this.openAvailabilityModal}>Edit</button>
                ) : (
                  <Switch
                    checked={false}
                    onChange={this.openAvailabilityModal}
                    onText="ON"
                    offText="OFF"
                  />
                )}
              </div>
            </div>
            {/* Session Duration */}
            <div className={classes.NetworkInfoCard}>
              <div className={classes.NetworkInfoRow}>
                <span className={classes.NetworkInfoLabel}>Session Duration</span>
                <span className={classes.NetworkInfoPipe}>|</span>
                {this.props.guestSessionLoading ? <Spinner /> : this.props.guestSessionPolling ? (
                  <span className={classes.NetworkInfoValue} style={{ flex: 1, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <FaSpinner className={classes.SpinnerIcon} style={{ color: '#0073d1' }} />
                    {'Applying session settings may take up to 90 seconds.'}
                    <span style={{ fontWeight: 600 }}>
                      {`${zeroPad(Math.floor(this.state.sessionCounter / 60))}:${zeroPad(this.state.sessionCounter % 60)}`}
                    </span>
                  </span>
                ) : (
                  <span className={classes.NetworkInfoValue} style={{ flex: 1 }}>
                    {this.props.guestSession?.duration
                      ? `${this.props.guestSession.duration} ${this.props.guestSession.units === 'HOURS' ? 'hours' : 'days'}`
                      : <span className={classes.SessionSelectPrompt}>Select duration</span>}
                  </span>
                )}
                <button className={classes.EditLink} onClick={this.openSessionModal} disabled={this.props.guestSessionPolling}>Edit</button>
              </div>
            </div>
          </div>
        )}

        {/* Network Info Section - IOT */}
        {activeTab === 'NetworkInfo' && selectedNetwork.wifiType === 'IOT' && (
          <div className={classes.DevicesSection}>
            {this.props.tenantDetailsError ? (
              <div className={classes.ErrorCard}>
                <div className={classes.ErrorIconRow}>
                  <FaExclamationCircle size={22} color="#d6312b" />
                  <span className={classes.ErrorTitle}>Error</span>
                </div>
                <p className={classes.ErrorMessage}>
                  UpStream service not available. Please refresh the page and try again. If error persists, please contact your supervisor.
                </p>
                <button className={classes.RefreshLink} onClick={() => this.props.getTenantData({})}>Refresh</button>
              </div>
            ) : this.props.tenantDetails && this.props.tenantDetails.content ? (
              <>
                <div className={classes.IotStatsWrapper}>
                  <ResidentNetworks
                    getTenantData={this.props.getTenantData}
                    tenantStats={this.props.tenantStats}
                    filter={this.props.filter}
                    isLoading={this.props.tenantDetailsLoading}
                    tenantDetails={this.props.tenantDetails}
                  />
                </div>
                <div className={classes.IotTableWrapper}>
                  <PspView
                    tenantDetails={this.props.tenantDetails}
                    getTenantData={this.props.getTenantData}
                    onGetTenant={this.props.onGetTenant}
                    filter={this.props.filter}
                    isLoading={this.props.tenantDetailsLoading}
                    iotConfigured={this.props.iotConfigured}
                  />
                </div>
              </>
            ) : (
              <Spinner />
            )}
          </div>
        )}


        {/* Edit WiFi Network Details Modal */}
        <Modal show={showEditModal} modalClosed={this.handleCancelEdit} deviceGroupConfirmation="true">
          <div className={classes.EditModalBody}>
            <h3 className={classes.EditModalTitle}>Edit WiFi Network Details</h3>

            {this.props.updateNetworkError && !this.state.retrying ? (
              <>
                <div className={classes.ApiErrorBox}>
                  <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0 }} />
                  <div>
                    <p className={classes.ApiErrorText}>Unable to load WiFi Network Details. Please try again.</p>
                    <button className={classes.TryAgainBtn} onClick={this.handleRetry}>Try again</button>
                  </div>
                </div>
                <div className={classes.EditModalActions}>
                  <div style={{ flex: 1 }} />
                  <button className={classes.CancelBtn} style={{ flex: 'none', width: '160px' }} onClick={this.handleCancelEdit}>Cancel</button>
                </div>
              </>
            ) : this.state.retrying ? (
              <Spinner />
            ) : (
              <>
                {/* SSID Guidelines */}
            <div className={classes.GuidelinesDropdown}>
              <button
                className={classes.GuidelinesToggle}
                onClick={() => this.setState({ showSsidGuidelines: !this.state.showSsidGuidelines })}
              >
                <span>Guidelines</span>
                <span className={[classes.GuidelinesChevron, this.state.showSsidGuidelines ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
              </button>
              {this.state.showSsidGuidelines && (
                <div className={classes.GuidelinesContent}>
                  <ul className={classes.GuidelinesList}>
                    <li>Please keep the length between 3-32 characters.</li>
                    <li>Don't begin or end with a symbol or space.</li>
                    <li>The following characters are not allowed $ {'<'} {'>'} ` \ ^ &amp; ; "</li>
                  </ul>
                </div>
              )}
            </div>

            <div className={classes.EditField}>
              <label className={classes.EditLabel}>Network Name (SSID) *</label>
              <input
                className={[classes.EditInput, ssidError ? classes.EditInputError : ''].join(' ')}
                type="text"
                value={editSsidName}
                minLength={3}
                maxLength={32}
                onChange={this.handleSsidChange}
              />
              {ssidError && <span className={classes.FieldError}>{ssidError}</span>}
            </div>

            {/* Password Guidelines - only for non-GUEST networks */}
            {this.isPasswordEditable() && (
            <div className={classes.GuidelinesDropdown}>
              <button
                className={classes.GuidelinesToggle}
                onClick={() => this.setState({ showPasswordGuidelines: !this.state.showPasswordGuidelines })}
              >
                <span>Guidelines</span>
                <span className={[classes.GuidelinesChevron, this.state.showPasswordGuidelines ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
              </button>
              {this.state.showPasswordGuidelines && (
                <div className={classes.GuidelinesContent}>
                  <ul className={classes.GuidelinesList}>
                    <li>Please keep the length between 8-29 characters.</li>
                    <li>Don't begin or end with a symbol or space.</li>
                    <li>The following characters are not allowed $ {'<'} {'>'} ` \ ^ &amp; ; " '</li>
                  </ul>
                </div>
              )}
            </div>
            )}

            {this.isPasswordEditable() && (
            <div className={classes.EditField}>
              <label className={classes.EditLabel}>Password *</label>
              <div className={classes.PasswordInputWrapper}>
                <input
                  className={[classes.EditInput, passwordError ? classes.EditInputError : ''].join(' ')}
                  type={showEditPassword ? 'text' : 'password'}
                  value={editPassword}
                  minLength={8}
                  maxLength={29}
                  onChange={this.handlePasswordChange}
                />
                <button
                  className={classes.EyeBtn}
                  onClick={() => this.setState({ showEditPassword: !showEditPassword })}
                  aria-label="toggle password visibility"
                >
                  {showEditPassword ? <FaEyeSlash size={18} color="#0073d1" /> : <FaEye size={18} color="#0073d1" />}
                </button>
              </div>
              {passwordError && <span className={classes.FieldError}>{passwordError}</span>}
            </div>
            )}

            <div className={classes.EditField}>
              <div className={classes.VisibilityRow}>
                <span className={classes.EditLabel} style={{ marginBottom: 0 }}>Network Visibility</span>
                <span className={classes.VisibilityInfoWrapper}>
                  <FaExclamationCircle size={14} color="#0073d1" style={{ marginLeft: 6, cursor: 'pointer' }} />
                  <div className={classes.VisibilityTooltip}>This allows the network to be hidden or visible</div>
                </span>
              </div>
              <div style={{ marginTop: 8 }}>
                <Switch
                  checked={editBroadcast}
                  onChange={() => this.setState({ editBroadcast: !editBroadcast })}
                  onText="ON"
                  offText="OFF"
                />
              </div>
            </div>

            <div className={classes.EditModalActions}>
              <button className={classes.CancelBtn} onClick={this.handleCancelEdit}>Cancel</button>
              <button
                className={classes.SaveBtn}
                onClick={this.handleSave}
                disabled={
                  !editSsidName ||
                  !!ssidError ||
                  (this.isPasswordEditable() && (!editPassword || !!passwordError)) ||
                  (
                    editSsidName === (selectedNetwork.wifiSsidName || '') &&
                    editBroadcast === (selectedNetwork.broadcast !== undefined ? selectedNetwork.broadcast : true) &&
                    (!this.isPasswordEditable() || editPassword === (selectedNetwork.wifiSsidPassphrase || ''))
                  )
                }
              >
                Save Changes
              </button>
            </div>
            </>
            )}
          </div>
        </Modal>

        {/* Confirmation Modal */}
        <Modal show={showConfirmModal} modalClosed={() => this.setState({ showConfirmModal: false, showEditModal: true })} deviceGroupConfirmation="true">
          <div className={classes.ConfirmModalBody}>
            <div className={classes.ConfirmHeader}>
              <FaExclamationCircle size={22} color="#fff" style={{ marginRight: 10, flexShrink: 0 }} />
              <h3 className={classes.ConfirmTitle}>Change WiFi Network Details?</h3>
            </div>
            <div className={classes.ConfirmContent}>
              <p className={classes.ConfirmText}>
                Changing the WiFi Network Details will disconnect any devices that are currently connected.
                Devices can be reconnected with the new network details.
              </p>
              <p className={classes.ConfirmText}>Are you sure you want to change the WiFi Network Details?</p>

              <div className={classes.ConfirmField}>
                <div className={classes.ConfirmFieldLabel}>Network Name (SSID)</div>
                <div className={classes.ConfirmFieldValue}>{editSsidName}</div>
              </div>

              {this.isPasswordEditable() && (
              <div className={classes.ConfirmField}>
                <div className={classes.ConfirmFieldLabel}>Password</div>
                <div className={classes.ConfirmFieldValue}>
                  <span>{showConfirmPassword ? editPassword : '••••••••••'}</span>
                  <button
                    className={classes.ShowPasswordBtn}
                    onClick={() => this.setState({ showConfirmPassword: !showConfirmPassword })}
                  >
                    {showConfirmPassword ? 'Hide Password' : 'Show Password'}
                  </button>
                </div>
              </div>
              )}

              <div className={classes.ConfirmNote}>
                <strong>Note:</strong> Devices using MAC randomization will lose details for username, pause
                schedules, IP reservations, groups and port forwarding. Devices that use MAC randomization
                will have duplicate entries in the device list upon reconnecting the device.
              </div>

              <div className={classes.ConfirmActions}>
                <button className={classes.CancelBtn} onClick={() => this.setState({ showConfirmModal: false, showEditModal: true })}>Cancel</button>
                <button
                  className={classes.SaveBtn}
                  onClick={this.handleConfirm}
                  disabled={updateNetworkLoading}
                >
                  {updateNetworkLoading ? 'Saving...' : 'Confirm'}
                </button>
              </div>
            </div>
          </div>
        </Modal>

        {/* Success Modal */}
        <Modal show={this.state.showSuccessModal} modalClosed={() => this.setState({ showSuccessModal: false })}>
          <Success message="WiFi Network Details updated successfully!" />
        </Modal>

        {/* Network Availability Modal */}
        <Modal show={showAvailabilityModal} modalClosed={() => this.setState({ showAvailabilityModal: false, availabilityApiError: null })} deviceGroupConfirmation="true">
          <div className={classes.EditModalBody}>
            <h3 className={classes.EditModalTitle}>Network Availability</h3>
            {this.state.availabilityApiError?.status === 404 && !this.state.availabilityApiError?.fromSave ? (
              <>
                <div className={classes.ApiErrorBox}>
                  <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0 }} />
                  <div style={{ flex: 1 }}>
                    <p className={classes.ApiErrorText}>Unable to load Network Availability. Please try again.</p>
                    <button className={classes.TryAgainBtn} onClick={this.handleSaveAvailability}>Try Again</button>
                  </div>
                </div>
                <div className={classes.EditModalActions}>
                  <button className={classes.CancelBtn} onClick={() => this.setState({ showAvailabilityModal: false, availabilityApiError: null })}>Cancel</button>
                </div>
              </>
            ) : (
              <>
                <p style={{ fontSize: 14, color: '#555', marginBottom: 20 }}>
                  By default, guests can access this network at all times. If you want to control when guests can use the network, set availability.
                </p>
                {this.state.availabilityApiError?.message && (
                  <div className={classes.ApiErrorBox}>
                    <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0, marginTop: 2 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <p className={classes.ApiErrorText} style={{ margin: 0 }}>Something went wrong. Please try again.</p>
                        <button
                          className={classes.TryAgainBtn}
                          style={{ fontSize: 16, padding: '0 4px' }}
                          onClick={() => this.setState(s => ({ showAvailabilityErrorDetails: !s.showAvailabilityErrorDetails }))}
                        >
                          <span className={[classes.GuidelinesChevron, this.state.showAvailabilityErrorDetails ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
                        </button>
                      </div>
                      <button className={classes.TryAgainBtn} style={{ marginTop: 4 }} onClick={this.handleSaveAvailability}>Try Again</button>
                      {this.state.showAvailabilityErrorDetails && (
                        <p className={classes.ApiErrorText} style={{ marginTop: 8, fontStyle: 'italic' }}>
                          {this.state.availabilityApiError.message}
                        </p>
                      )}
                    </div>
                  </div>
                )}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
                  <span style={{ fontSize: 14, color: '#333' }}>Customize Availability</span>
                  <Switch
                    checked={availabilityEnabled}
                    onChange={() => this.setState({ availabilityEnabled: !availabilityEnabled })}
                    onText="ON"
                    offText="OFF"
                  />
                </div>
                {availabilityEnabled && (
                  <>
                    <div style={{ marginBottom: 16 }}>
                      <div style={{ fontSize: 13, color: '#333', marginBottom: 8, fontWeight: 600 }}>Schedule Days</div>
                      <div className={classes.DayBtnRow}>
                        {DAYS.map((day, i) => {
                          const key = DAY_KEYS[i];
                          const selected = availabilityDays[key];
                          return (
                            <button
                              key={key}
                              onClick={() => this.setState(prev => ({ availabilityDays: { ...prev.availabilityDays, [key]: !prev.availabilityDays[key] } }))}
                              className={selected ? classes.DayBtnSelected : classes.DayBtn}
                            >
                              {day}
                            </button>
                          );
                        })}
                        <button className={classes.ResetBtn} onClick={() => {
                          const defaults = this.getDefaultAvailabilityState();
                          this.setState({
                            availabilityDays: { ...defaults.availabilityDays },
                            availabilityStartHour: defaults.availabilityStartHour,
                            availabilityStartMinute: defaults.availabilityStartMinute,
                            availabilityStartAmPm: defaults.availabilityStartAmPm,
                            availabilityStopHour: defaults.availabilityStopHour,
                            availabilityStopMinute: defaults.availabilityStopMinute,
                            availabilityStopAmPm: defaults.availabilityStopAmPm,
                            _initialAvailability: this.state._initialAvailability,
                          });
                        }}>
                          <FaRedo size={13} style={{ marginRight: 5 }} />
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className={classes.TimePickerRow}>
                      <div className={classes.TimePickerGroup}>
                        <div style={{ fontSize: 13, color: '#333', marginBottom: 8, fontWeight: 600 }}>Start Time</div>
                        <div className={classes.TimeSelectGroup}>
                          <select className={classes.TimeSelect} value={availabilityStartHour} onChange={e => this.setState({ availabilityStartHour: parseInt(e.target.value) })}>
                            {HOURS.map(h => <option key={h} value={h}>{String(h).padStart(2,'0')}</option>)}
                          </select>
                          <select className={classes.TimeSelect} value={availabilityStartAmPm} onChange={e => this.setState({ availabilityStartAmPm: e.target.value })}>
                            <option>AM</option><option>PM</option>
                          </select>
                        </div>
                      </div>
                      <span className={classes.TimeSeparator}>–</span>
                      <div className={classes.TimePickerGroup}>
                        <div style={{ fontSize: 13, color: '#333', marginBottom: 8, fontWeight: 600 }}>Stop Time</div>
                        <div className={classes.TimeSelectGroup}>
                          <select className={classes.TimeSelect} value={availabilityStopHour} onChange={e => this.setState({ availabilityStopHour: parseInt(e.target.value) })}>
                            {HOURS.map(h => <option key={h} value={h}>{String(h).padStart(2,'0')}</option>)}
                          </select>
                          <select className={classes.TimeSelect} value={availabilityStopAmPm} onChange={e => this.setState({ availabilityStopAmPm: e.target.value })}>
                            <option>AM</option><option>PM</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </>
                )}
                <div className={classes.EditModalActions}>
                  <button className={classes.CancelBtn} onClick={() => this.setState({ showAvailabilityModal: false, availabilityApiError: null })}>Cancel</button>
                  <button
                    className={classes.SaveBtn}
                    onClick={this.handleSaveAvailability}
                    disabled={this.props.updateGuestScheduleLoading || !this.hasAvailabilityChanged() || (availabilityEnabled && !DAY_KEYS.some(k => availabilityDays[k]))}
                  >
                    {this.props.updateGuestScheduleLoading ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal>

        {/* Session Duration Modal */}
        <Modal show={showSessionModal} modalClosed={() => !this.props.updateGuestSessionLoading && !this.props.guestSessionPolling && this.setState({ showSessionModal: false, sessionApiError: null })} deviceGroupConfirmation="true">
          <div className={classes.EditModalBody}>
            <h3 className={classes.EditModalTitle}>Session Duration</h3>
            {this.props.updateGuestSessionLoading ? (
              <div style={{ padding: '30px 0', textAlign: 'center' }}>
                <Spinner />
                <p style={{ marginTop: 12, fontSize: 14, color: '#555' }}>Saving session settings...</p>
              </div>
            ) : this.props.guestSessionPolling ? (
              <div style={{ padding: '30px 0', textAlign: 'center' }}>
                <FaSpinner className={classes.SpinnerIcon} style={{ color: '#0073d1', fontSize: 28 }} />
                <p style={{ marginTop: 12, fontSize: 14, color: '#555' }}>Applying session settings may take up to 90 seconds.</p>
                <p style={{ fontSize: 16, fontWeight: 600, color: '#333' }}>
                  {`${zeroPad(Math.floor(this.state.sessionCounter / 60))}:${zeroPad(this.state.sessionCounter % 60)}`}
                </p>
              </div>
            ) : this.state.sessionApiError?.status === 404 && !this.state.sessionApiError?.fromSave ? (
              <>
                <div className={classes.ApiErrorBox}>
                  <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0 }} />
                  <div style={{ flex: 1 }}>
                    <p className={classes.ApiErrorText}>Unable to load Session Duration. Please try again.</p>
                    <button className={classes.TryAgainBtn} onClick={this.handleSaveSession}>Try Again</button>
                  </div>
                </div>
                <div className={classes.EditModalActions}>
                  <button className={classes.CancelBtn} onClick={() => this.setState({ showSessionModal: false, sessionApiError: null })}>Cancel</button>
                </div>
              </>
            ) : (
              <>
                <p style={{ fontSize: 14, color: '#555', marginBottom: 20 }}>
                  Set the length of time guests can have on the WiFi network.
                </p>
                {this.state.sessionApiError?.message && (
                  <div className={classes.ApiErrorBox}>
                    <FaExclamationCircle size={20} color="#c0392b" style={{ flexShrink: 0, marginTop: 2 }} />
                    <div style={{ flex: 1 }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <p className={classes.ApiErrorText} style={{ margin: 0 }}>Something went wrong. Please try again.</p>
                        <button
                          className={classes.TryAgainBtn}
                          style={{ fontSize: 16, padding: '0 4px' }}
                          onClick={() => this.setState(s => ({ showSessionErrorDetails: !s.showSessionErrorDetails }))}
                        >
                          <span className={[classes.GuidelinesChevron, this.state.showSessionErrorDetails ? classes.GuidelinesChevronOpen : ''].join(' ')}>&#8964;</span>
                        </button>
                      </div>
                      <button className={classes.TryAgainBtn} style={{ marginTop: 4 }} onClick={this.handleSaveSession}>Try Again</button>
                      {this.state.showSessionErrorDetails && (
                        <p className={classes.ApiErrorText} style={{ marginTop: 8, fontStyle: 'italic' }}>{this.state.sessionApiError.message}</p>
                      )}
                    </div>
                  </div>
                )}
                <div className={classes.EditField}>
                  <label className={classes.EditLabel}>Session Duration</label>
                  <SelectDropdown
                    height={'44px'}
                    width={'100%'}
                    name="sessionDuration"
                    placeholder="Select duration"
                    value={sessionDuration.value ? SESSION_DURATION_OPTIONS.find(o => o.value === sessionDuration.value) || null : null}
                    options={SESSION_DURATION_OPTIONS}
                    isSearchable={false}
                    onChange={(opt) => this.setState({ sessionDuration: opt })}
                  />
                </div>
                <div className={classes.EditModalActions}>
                  <button className={classes.CancelBtn} onClick={() => this.setState({ showSessionModal: false, sessionApiError: null })}>Cancel</button>
                  <button
                    className={classes.SaveBtn}
                    onClick={this.handleSaveSession}
                    disabled={this.props.updateGuestSessionLoading || !sessionDuration.value}
                  >
                    {this.props.updateGuestSessionLoading ? 'Saving...' : 'Save'}
                  </button>
                </div>
              </>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedNetwork: state.propertyIOTNetwork.selectedNetwork,
  networkDevices: state.propertyIOTNetwork.networkDevices,
  networkDevicesLoading: state.propertyIOTNetwork.networkDevicesLoading,
  networkDevicesLoaded: state.propertyIOTNetwork.networkDevicesLoaded,
  networkDevicesError: state.propertyIOTNetwork.networkDevicesError,
  updateNetworkLoading: state.propertyIOTNetwork.updateNetworkLoading,
  updateNetworkSuccess: state.propertyIOTNetwork.updateNetworkSuccess,
  updateNetworkError: state.propertyIOTNetwork.updateNetworkError,
  deleteNetworkLoading: state.propertyIOTNetwork.deleteNetworkLoading,
  deleteNetworkSuccess: state.propertyIOTNetwork.deleteNetworkSuccess,
  deleteNetworkError: state.propertyIOTNetwork.deleteNetworkError,
  guestSession: state.propertyIOTNetwork.guestSession,
  guestSessionLoading: state.propertyIOTNetwork.guestSessionLoading,
  guestSessionError: state.propertyIOTNetwork.guestSessionError,
  updateGuestSessionLoading: state.propertyIOTNetwork.updateGuestSessionLoading,
  updateGuestSessionSuccess: state.propertyIOTNetwork.updateGuestSessionSuccess,
  updateGuestSessionError: state.propertyIOTNetwork.updateGuestSessionError,
  guestSessionPolling: state.propertyIOTNetwork.guestSessionPolling,
  guestSchedule: state.propertyIOTNetwork.guestSchedule,
  guestScheduleLoading: state.propertyIOTNetwork.guestScheduleLoading,
  guestScheduleError: state.propertyIOTNetwork.guestScheduleError,
  updateGuestScheduleLoading: state.propertyIOTNetwork.updateGuestScheduleLoading,
  updateGuestScheduleSuccess: state.propertyIOTNetwork.updateGuestScheduleSuccess,
  updateGuestScheduleError: state.propertyIOTNetwork.updateGuestScheduleError,
  tenantDetails: state.propertyManager.tenantDetails,
  tenantStats: state.propertyManager.tenantStats,
  tenantDetailsLoading: state.propertyManager.tenantDetailsLoading,
  tenantDetailsError: state.propertyManager.tenantDetailsError,
  filter: state.propertyManager.filter,
  iotConfigured: state.propertyIOTNetwork.getIOTssidNetwork?.wifiSsidPassphrase,
  isSpectrumReady: state.propertyManager.tenantDetails?.isSpectrumReady === true,
  accountClassification: state.propertyManager.tenantDetails?.accountClassification,
  devicePauseState: state.propertyIOTNetwork.devicePauseState,
  devicePauseStateLoading: state.propertyIOTNetwork.devicePauseStateLoading,
  pauseNetworkDeviceLoading: state.propertyIOTNetwork.pauseNetworkDeviceLoading,
  pauseNetworkDeviceSuccess: state.propertyIOTNetwork.pauseNetworkDeviceSuccess,
  pauseNetworkDeviceError: state.propertyIOTNetwork.pauseNetworkDeviceError,
  devicePauseStateError: state.propertyIOTNetwork.devicePauseStateError,
});

const mapDispatchToProps = (dispatch) => ({
  getNetworkDevices: (wifiType) => dispatch(actions.getNetworkDevices(wifiType)),
  updateNetwork: (payload) => dispatch(actions.updateNetwork(payload)),
  clearUpdateNetworkError: () => dispatch(actions.clearUpdateNetworkError()),
  getNetworks: () => dispatch(actions.getNetworks()),
  getTenantData: (payload) => dispatch(actions.getPropertyManagerTenantDetails(
    payload?.connectionStatuses,
    payload?.search,
    payload?.page,
    payload?.size
  )),
  onGetTenant: (masterAcct, tenantAcct) => dispatch(actions.startAppSaga(masterAcct, tenantAcct)),
  setSelectedNetwork: (network) => dispatch(actions.setSelectedNetwork(network)),
  getGuestNetworkSession: () => dispatch(actions.getGuestNetworkSession()),
  updateGuestNetworkSession: (payload) => dispatch(actions.updateGuestNetworkSession(payload)),
  getGuestNetworkSchedule: () => dispatch(actions.getGuestNetworkSchedule()),
  updateGuestNetworkSchedule: (payload) => dispatch(actions.updateGuestNetworkSchedule(payload)),
  clearGuestNetworkError: () => dispatch(actions.clearGuestNetworkError()),
  getNetworkDevicePauseState: (macAddress) => dispatch(actions.getNetworkDevicePauseState(macAddress)),
  clearDevicePauseStateError: () => dispatch(actions.clearDevicePauseStateError()),
  clearPauseNetworkDeviceError: () => dispatch(actions.clearPauseNetworkDeviceError()),
  pauseNetworkDevice: (payload) => dispatch(actions.pauseNetworkDevice(payload)),
  unpauseNetworkDevice: (payload) => dispatch(actions.unpauseNetworkDevice(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NetworksPage);
